import React, { Component } from 'react';
import { Modal, Button, Alert, Collapse, Table, Tag, Checkbox, message, Spin } from 'antd';
import axios from 'axios';
import CondPagtoFrame from './CondPagtoFrame';
import TipoDocFrame from './TipoDocFrame';
import { getUsuario } from '../utils/LoginManager';
import moment from 'moment-timezone';
import ProdutoFrame from './ProdutoFrame';

const { Panel } = Collapse;
const dinheiro = value => Number(value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
const erroApi = error => {
  const data = error.response && error.response.data;
  return (data && data.mensagem) || (typeof data === 'string' && data.length < 500 ? data : '') ||
    'Não foi possível confirmar a operação. Analise os arquivos novamente antes de reenviar.';
};

export default class VendasImportarXmlModal extends Component {
  state = { arquivos: [], resultados: [], ocupado: false, analisando: false, confirmado: false, erro: '' };

  usuario = getUsuario();

  parcelas = r => {
    const quantidade = Number(r.condicao && r.condicao.qtdeParc);
    if (!Number.isInteger(quantidade) || quantidade < 1 || quantidade > 360) return [];
    const centavos = Math.round(r.nota.total * 100);
    if (centavos < quantidade) return [];
    const base = Math.floor(centavos / quantidade);
    const avista = Number(r.condicao.parcAVista) === 1 || r.condicao.parcAVista === true;
    return Array.from({ length: quantidade }, (_, i) => ({
      numero: i + 1,
      vencimento: moment(r.nota.emissao.substring(0, 10)).add(i + (avista ? 0 : 1), 'months').format('DD/MM/YYYY'),
      valor: (i === quantidade - 1 ? centavos - base * (quantidade - 1) : base) / 100,
    }));
  };

  selecionar = event => {
    const arquivos = Array.from(event.target.files || []);
    event.target.value = '';
    const erro = arquivos.length > 20 ? 'Selecione até 20 arquivos por lote.' :
      arquivos.some(f => !/\.xml$/i.test(f.name)) ? 'Selecione apenas arquivos XML.' :
      arquivos.some(f => f.size > 2 * 1024 * 1024) ? 'Cada XML deve ter no máximo 2 MB.' :
      arquivos.reduce((s, f) => s + f.size, 0) > 10 * 1024 * 1024 ? 'O lote deve ter no máximo 10 MB.' : '';
    this.setState({ arquivos: erro ? [] : arquivos, resultados: [], confirmado: false, erro });
  };

  analisar = async () => {
    if (this.state.ocupado || !this.state.arquivos.length) return;
    const form = new FormData();
    this.state.arquivos.forEach(file => form.append('arquivos[]', file));
    this.setState({ ocupado: true, analisando: true, erro: '', resultados: [], confirmado: false });
    try {
      const { data } = await axios.post('/vendas/importar-xml/analisar', form);
      this.setState({ resultados: data.resultados.map(r => ({
        ...r, cliente: r.nota && r.nota.cliente ? r.nota.cliente : { key: '0' }, vinculos: {},
        condicao: data.padroes ? data.padroes.condicao : { key: String(this.usuario.par_cond_pagto_padrao || '0'), label: this.usuario.cp_descricao,
          qtdeParc: this.usuario.cp_qtde_parc, parcAVista: this.usuario.cp_parc_avista },
        documento: data.padroes ? data.padroes.documento : { key: String(this.usuario.par_doc_padrao || '0'), label: this.usuario.td_descricao },
      })) });
    } catch (error) {
      this.setState({ erro: erroApi(error) });
    } finally {
      this.setState({ ocupado: false, analisando: false });
    }
  };

  alterar = (indice, changes) => this.setState(state => ({
    resultados: state.resultados.map(r => r.indice === indice ? { ...r, ...changes } : r),
  }));

  vincular = (indice, seq, produto) => this.setState(state => ({
    resultados: state.resultados.map(r => r.indice === indice ? {
      ...r, vinculos: { ...r.vinculos, [seq]: produto }, erroImportacao: '',
    } : r),
  }));

  pendencias = r => {
    if ((!r.cliente || Number(r.cliente.key) <= 0) && !r.nota.cliente_novo) return 'Não foi possível identificar o cliente no XML.';
    if (!r.condicao || Number(r.condicao.key) <= 0) return 'Informe a condição de pagamento.';
    if (!r.documento || Number(r.documento.key) <= 0) return 'Informe o tipo de documento.';
    if (!Number(this.usuario.par_cta_corrente_padrao) || !Number(this.usuario.par_pc_venda)) return 'Configure a conta corrente padrão e o plano de contas de vendas.';
    if (!this.parcelas(r).length) return 'Selecione uma condição com quantidade de parcelas válida.';
    const item = r.nota.itens.find(i => {
      const p = r.vinculos[i.seq];
      return !p || !Number(p.pest_item) || p.pest_tamanho == null || p.pest_cor == null;
    });
    return item ? `Vincule o produto do item ${item.seq}, incluindo a variação.` : '';
  };

  importar = async () => {
    if (this.state.ocupado) return;
    const notas = this.state.resultados.filter(r => r.nota && !r.importada);
    if (!notas.length || !this.state.confirmado) return;
    const pendente = notas.find(r => this.pendencias(r));
    if (pendente) {
      message.warning(`${pendente.arquivo}: ${this.pendencias(pendente)}`);
      return;
    }
    this.setState({ ocupado: true, erro: '' });
    let sucesso = 0;
    try {
      // Sequencial: permite resultado por arquivo e reduz disputas no estoque.
      for (const registro of notas) {
        this.alterar(registro.indice, { status: 'Importando...', erroImportacao: '' });
        const vinculos = {};
        registro.nota.itens.forEach(item => {
          const p = registro.vinculos[item.seq];
          vinculos[item.seq] = { produto: p.pest_item, tamanho: p.pest_tamanho, cor: p.pest_cor };
        });
        const form = new FormData();
        form.append('arquivo', this.state.arquivos[registro.indice]);
        form.append('cliente', registro.cliente.key);
        form.append('condicao_pagamento', registro.condicao.key);
        form.append('tipo_documento', registro.documento.key);
        form.append('vinculos', JSON.stringify(vinculos));
        try {
          const { data } = await axios.post('/vendas/importar-xml/confirmar', form);
          sucesso++;
          this.alterar(registro.indice, { importada: true, cliente: data.cliente || registro.cliente,
            status: `Venda ${data.numero} importada${data.cliente_criado ? ' — cliente cadastrado automaticamente' : ''}`, erroImportacao: '' });
        } catch (error) {
          this.alterar(registro.indice, { status: '', erroImportacao: erroApi(error) });
        }
      }
      if (sucesso) {
        message.success(`${sucesso} venda(s) importada(s). A lista respeita o filtro de datas atual.`);
        this.props.onImportado();
      }
    } finally {
      this.setState({ ocupado: false, analisando: false });
    }
  };

  renderNota = r => {
    const { ocupado } = this.state;
    const nota = r.nota;
    const desabilitado = ocupado || r.importada;
    return (
      <div>
        <p><strong>Emitente:</strong> {nota.cnpj} · <strong>Emissão:</strong> {nota.emissao}<br />
          <strong>Destinatário no XML:</strong> {nota.destinatario} {nota.documento}<br />
          <strong>Chave:</strong> <span style={{ wordBreak: 'break-all' }}>{nota.chave}</span></p>
        <Alert type={nota.cliente_novo && !r.importada ? 'info' : 'success'} showIcon
          message={nota.cliente_novo && !r.importada
            ? `Cliente não cadastrado: ${r.cliente.label}. Será cadastrado automaticamente ao importar.`
            : `Cliente cadastrado: ${r.cliente.label}`} style={{ marginBottom: 12 }} />
        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
          <div style={{ flex: '1 1 280px' }}>
            <CondPagtoFrame id="ven_cond_pagto" label="Condição de pagamento *" width="100%"
              value={r.condicao} disabled={desabilitado}
              onChange={e => this.alterar(r.indice, { condicao: e.ven_cond_pagto })} />
          </div>
          <div style={{ flex: '1 1 280px' }}>
            <TipoDocFrame id="ven_tipo_doc" label="Tipo de documento *" width="100%"
              value={r.documento} disabled={desabilitado}
              onChange={e => this.alterar(r.indice, { documento: e.ven_tipo_doc })} />
          </div>
        </div>
        <p>Conta corrente: {this.usuario.cc_descricao || this.usuario.par_cta_corrente_padrao || 'Não configurada'} ·
          Plano de contas de vendas: {this.usuario.par_pc_venda || 'Não configurado'}</p>
        <Table size="small" rowKey="numero" pagination={false} dataSource={this.parcelas(r)}
          style={{ marginBottom: 16 }} columns={[
            { title: 'Parcela', dataIndex: 'numero' }, { title: 'Vencimento', dataIndex: 'vencimento' },
            { title: 'Valor a receber', dataIndex: 'valor', render: dinheiro },
          ]} />
        <Table dataSource={nota.itens} rowKey="seq" pagination={false} size="small" scroll={{ x: 960 }}
          columns={[
            { title: 'Item do XML', key: 'xml', width: 270, render: (_, i) => (
              <div><strong>{i.seq}. {i.descricao}</strong><br />Código: {i.codigo}<br />NCM: {i.ncm} · CFOP: {i.cfop}</div>
            ) },
            { title: 'Quantidade / unidade', key: 'qtde', width: 140, render: (_, i) => `${i.quantidade} ${i.unidade}` },
            { title: 'Unitário / total', key: 'valor', width: 150, render: (_, i) => (
              <div>{dinheiro(i.unitario)}<br /><strong>{dinheiro(i.total)}</strong></div>
            ) },
            { title: 'Produto correspondente no FastGestor *', key: 'produto', width: 400, render: (_, i) => (
              <ProdutoFrame id="mi_item" label="" width="100%" disabled={desabilitado}
                value={r.vinculos[i.seq] || { key: '0' }}
                onChange={event => this.vincular(r.indice, i.seq, event.mi_item)} />
            ) },
          ]} />
        <p style={{ marginTop: 12 }}>Produtos: {dinheiro(nota.bruto)} · Descontos: {dinheiro(nota.desconto)} ·
          Acréscimos (frete, tributos e demais valores): {dinheiro(nota.acrescimo)} · <strong>Total: {dinheiro(nota.total)}</strong></p>
        {!r.importada && <Alert type="info" showIcon message={this.pendencias(r) || 'Nota pronta para importar.'} />}
        {r.erroImportacao && <Alert style={{ marginTop: 8 }} type="error" showIcon message={r.erroImportacao} />}
        {r.status && <Alert style={{ marginTop: 8 }} type={r.importada ? 'success' : 'info'} message={r.status} />}
      </div>
    );
  };

  render() {
    const { arquivos, resultados, ocupado, analisando, confirmado, erro } = this.state;
    const notas = resultados.filter(r => r.nota && !r.importada);
    return (
      <Modal visible title="Importar vendas de XML de NF-e / NFC-e" width="95%"
        style={{ top: 20, maxWidth: 1250 }} maskClosable={false} closable={!ocupado} keyboard={!ocupado}
        onCancel={() => !ocupado && this.props.onCancelar()}
        footer={[
          <Button key="fechar" disabled={ocupado} onClick={this.props.onCancelar}>Fechar</Button>,
          <Button key="importar" type="primary" icon="import" loading={ocupado && !analisando}
            disabled={ocupado || !confirmado || !notas.length || notas.some(r => this.pendencias(r))}
            onClick={this.importar}>Importar {notas.length || ''} venda(s)</Button>,
        ]}>
        <Spin spinning={analisando} tip="Analisando arquivos XML, aguarde...">
        <Alert type="info" showIcon message="Selecione os XMLs e vincule todos os produtos antes de importar."
          description="Somente notas autorizadas de saída, modelos 55 e 65, de produção e do mesmo CNPJ base (primeiros 8 dígitos) da empresa logada. Até 20 XMLs, 2 MB por arquivo e 10 MB por lote. Arquivos inválidos serão ignorados e exibidos abaixo." />
        <div style={{ margin: '16px 0', display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center' }}>
          <input type="file" multiple accept=".xml,text/xml,application/xml" disabled={ocupado}
            aria-label="Selecionar arquivos XML" onChange={this.selecionar} />
          <Button icon="file-search" loading={analisando} onClick={this.analisar} disabled={ocupado || !arquivos.length}>{analisando ? 'Analisando arquivos...' : `Analisar ${arquivos.length || ''} arquivo(s)`}</Button>
        </div>
        {arquivos.length > 0 && <p style={{ wordBreak: 'break-word' }}>{arquivos.map(f => f.name).join(', ')}</p>}
        {erro && <Alert type="error" showIcon message={erro} style={{ marginBottom: 12 }} />}
        <Collapse>
          {resultados.map(r => <Panel key={String(r.indice)} header={
            <span><Tag color={r.erro ? 'red' : r.importada ? 'green' : 'blue'}>{r.erro ? 'Bloqueada' : r.importada ? 'Importada' : 'Revisar'}</Tag>
              {r.arquivo}{r.nota ? ` — NF ${r.nota.numero}/${r.nota.serie} — ${dinheiro(r.nota.total)}` : ''}</span>
          }>{r.erro ? <Alert type="error" showIcon message={r.erro} /> : this.renderNota(r)}</Panel>)}
        </Collapse>
        {notas.length > 0 && <div style={{ marginTop: 16 }}>
          <Alert type="warning" showIcon message="A importação cria a venda, movimenta o estoque e gera contas a receber com parcelas em aberto. Não transmite outra nota fiscal."
            description="Confira cliente, condição de pagamento, tipo de documento, vencimentos, produto, tamanho/cor e unidade de medida. A primeira parcela vence na data da venda quando a condição indica entrada à vista; caso contrário, no mês seguinte. As demais são mensais. Nenhuma parcela é baixada automaticamente. A quantidade comercial do XML será usada sem conversão de unidade. Frete e tributos são rateados como acréscimos. A autorização é verificada no arquivo; o sistema não consulta cancelamentos posteriores na SEFAZ." />
          <Checkbox style={{ marginTop: 12 }} disabled={ocupado} checked={confirmado}
            onChange={event => this.setState({ confirmado: event.target.checked })}>
            Conferi os vínculos, unidades e parcelas e confirmo a movimentação de estoque e o contas a receber.
          </Checkbox>
        </div>}
        </Spin>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/VendasImportarXmlModal.js